var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      staticClass: "modal-content",
      attrs: { width: 650, visible: _vm.visible, footer: null },
      on: { cancel: _vm.hideModal },
    },
    [
      _c(
        "div",
        {
          staticStyle: {
            "font-size": "18px",
            "font-weight": "bold",
            color: "#333",
          },
          attrs: { slot: "title" },
          slot: "title",
        },
        [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]
      ),
      _c(
        "div",
        { staticClass: "container" },
        [
          _vm._l(_vm.recordList, function (item, index) {
            return _c("div", { key: index, staticClass: "row" }, [
              _c("div", { staticClass: "key" }, [_vm._v(_vm._s(item.key))]),
              _c("div", { staticStyle: { flex: "1" } }, [
                _vm._v(_vm._s(item.value)),
              ]),
            ])
          }),
          _c(
            "div",
            {
              staticStyle: {
                padding: "10px 0",
                "margin-left": "15px",
                color: "#1783e8",
                "font-weight": "bold",
              },
              on: { click: _vm.downloadFile },
            },
            [_vm._v("\n      家校园沟通记录表.doc 下载\n    ")]
          ),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }